import React from "react";
import { withRouter } from "react-router";
// Components
import LoginForm from "./login";
import ForgotPasswordForm from "./forgot-password";
import Otp from "./otp";
// style
import LrfStyle from "./style";
// image
import Logo from "../../Assets/Primis-Logo.svg";
import CreatePassword from "./create-password";

function Form(props) {
  const head = () => {
    switch (props.location.pathname) {
      case "/":
        return "Welcome !";
      case "/forgot-password":
        return "Forgot Password";
      case "/otp-validate":
        return "Verify Email OTP";
      case "/create-password":
        return "Create New Password";
      default:
        return "Welcome !";
    }
  };

  const SubHead = () => {
    switch (props.location.pathname) {
      case "/":
        return "Sign in to continue to V1be";
      case "/forgot-password":
        return "Enter the registered email ID";
      case "/otp-validate":
        return "Enter the six digit verification code sent to your email";
      case "/create-password":
        return "Password must be minimum 8 characters and contain both numbers and letters/special characters ";
      default:
        return "Sign in to continue to Primis";
    }
  };

  const Year = () => {
    const d = new Date();
    return d.getFullYear();
  };

  return (
    <>
      <div className="main-wrap">
        <div className="form-wrap dark-background text-center d-flex justify-content-center align-items-center">
          <div className="w-100 max-width-form">
            <img className="logo mb-4" src={Logo} alt="Logo" width="100" height="80" />
            <h5 className="f-20 text-center text-white font-weight-normal">{head()}</h5>
            <p className="f-14 text-center text-white font-weight-normal mb-0">{SubHead()}</p>
            {props.location.pathname === "/" && <LoginForm />}
            {props.location.pathname === "/forgot-password" && <ForgotPasswordForm />}
            {props.location.pathname === "/otp-validate" && <Otp />}
            {props.location.pathname === "/create-password" && <CreatePassword />}
            {props.location.pathname === "/reset-password" && <CreatePassword />}
            <p className="text-white text-center mt-5 pt-5 f-14">Copyright © {Year()} Primis. All rights reserved.</p>
          </div>
        </div>
        <LrfStyle />
      </div>
    </>
  );
}

export default withRouter(Form);
